var _circle, _circle2, _g, _g2, _g3, _g4, _rect, _ellipse, _ellipse2, _ellipse3, _g5, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroNewcomers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "78 56 380 282",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Three newcomers arriving in a Canadian city, with a job offer card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 200,
    r: 160,
    fill: "#dcfce7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 96,
    r: 34,
    fill: "#fee2e2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(361 77) scale(0.38)",
    fill: "#ef4444"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50,0 57,13 64,9 61,31 74,19 78,27 91,24 87,37 97,41 76,57 80,65 56,61 52,63 52,98 48,98 48,63 44,61 20,65 24,57 3,41 13,37 9,24 22,27 26,19 39,31 36,9 43,13"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#bbf7d0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 168,
    width: 40,
    height: 150,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 128,
    width: 36,
    height: 190,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 146,
    width: 40,
    height: 172,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 188,
    width: 48,
    height: 130,
    rx: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#86efac"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 102,
    width: 12,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 138,
    width: 32,
    height: 180,
    rx: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250,66 254,102 246,102"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 182,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 182,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 142,
    width: 8,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 142,
    width: 8,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 152,
    width: 7,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 152,
    width: 7,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 160,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 160,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 202,
    width: 11,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 202,
    width: 11,
    height: 11,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 318,
    width: 360,
    height: 8,
    rx: 4,
    fill: "#4ade80"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#15803d",
    opacity: 0.18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#15803d",
    opacity: 0.18
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#15803d",
    opacity: 0.18
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 318 q0 -9 9 -9 h3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 150 q0 -26 19 -26 q19 0 19 26 v44 q-19 8 -38 0 z",
    fill: "#9a3412"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#d7b79f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 186 q9 7 18 0",
    fill: "none",
    stroke: "#2f68c4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 194 Q118.5 223.0 118 252",
    fill: "none",
    stroke: "#3b82f6",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 252,
    r: 5.5,
    fill: "#f5d0b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 194 Q179.0 219.0 177 244",
    fill: "none",
    stroke: "#3b82f6",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 244,
    r: 5.5,
    fill: "#f5d0b5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 152,
    r: 18,
    fill: "#f5d0b5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 153,
    r: 3.5,
    fill: "#f5d0b5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 153,
    r: 3.5,
    fill: "#f5d0b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 154 q-1 -25 19 -25 q20 0 19 25 q-4 -12 -19 -13 q-15 1 -19 13 z",
    fill: "#9a3412"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 262 v-10 h16 v10",
    fill: "none",
    stroke: "#92400e",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 262,
    width: 28,
    height: 48,
    rx: 6,
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 276,
    width: 28,
    height: 4,
    fill: "#d97706"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 313,
    r: 3.5,
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 313,
    r: 3.5,
    fill: "#374151"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 190,
    width: 52,
    height: 50,
    rx: 12,
    fill: "#0f766e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 318 q0 -9 9 -9 h3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#6d4127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 186 q9 7 18 0",
    fill: "none",
    stroke: "#1b9d4b",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 194 Q206.5 218.0 208 242",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 242,
    r: 5.5,
    fill: "#7c4a2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 194 Q270.5 172.0 274 150",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 150,
    r: 5.5,
    fill: "#7c4a2d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 152,
    r: 18,
    fill: "#7c4a2d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 153,
    r: 3.5,
    fill: "#7c4a2d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 153,
    r: 3.5,
    fill: "#7c4a2d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 140,
    r: 8,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 134,
    r: 9,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 134,
    r: 9,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 141,
    r: 8,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 149,
    r: 6,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 149,
    r: 6,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 186 q-3 24 -2 46",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 186 q3 24 2 46",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 262,
    width: 9,
    height: 52,
    rx: 4.5,
    fill: "#ecc29b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 262,
    width: 9,
    height: 52,
    rx: 4.5,
    fill: "#ecc29b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 318 q0 -9 9 -9 h3 v9 z",
    fill: "#7c2d12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#7c2d12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 236 h32 l8 32 h-48 z",
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#cfaa88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 186 q9 7 18 0",
    fill: "none",
    stroke: "#c75c11",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 194 Q289.0 216.0 291 238",
    fill: "none",
    stroke: "#f97316",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 238,
    r: 5.5,
    fill: "#ecc29b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 194 Q347.5 211.0 346 228",
    fill: "none",
    stroke: "#f97316",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 228,
    r: 5.5,
    fill: "#ecc29b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 152,
    r: 18,
    fill: "#ecc29b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 153,
    r: 3.5,
    fill: "#ecc29b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 153,
    r: 3.5,
    fill: "#ecc29b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 128,
    r: 9,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 151 q-1 -21 18 -21 q19 0 18 21 q-5 -10 -18 -11 q-13 1 -18 11 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-6 350 221)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 206,
    width: 24,
    height: 30,
    rx: 3,
    fill: "#ffffff",
    stroke: "#16a34a",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 213,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#16a34a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 220,
    width: 10,
    height: 3,
    rx: 1.5,
    fill: "#d1d5db"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(358 250) rotate(4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    rx: 11,
    fill: "#ffffff",
    stroke: "#bbf7d0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 10,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19 l3.5 3.5 l7 -7.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 12,
    width: 50,
    height: 6,
    rx: 3,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#d1d5db"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 73,
    height: 7,
    rx: 3.5,
    fill: "#dcfce7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 46,
    height: 7,
    rx: 3.5,
    fill: "#22c55e"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#f59e0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 112 l4 9 l9 4 l-9 4 l-4 9 l-4 -9 l-9 -4 l9 -4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 172 l3 6 l6 3 l-6 3 l-3 6 l-3 -6 l-6 -3 l6 -3 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroNewcomers);
export default __webpack_public_path__ + "static/media/hero-newcomers.a8a016b184925729bce854c8f37c33a0.svg";
export { ForwardRef as ReactComponent };